import { render, staticRenderFns } from "./DragAndDropMultiple.vue?vue&type=template&id=3e06b6ba&scoped=true"
import script from "./DragAndDropMultiple.vue?vue&type=script&lang=js"
export * from "./DragAndDropMultiple.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropMultiple.vue?vue&type=style&index=0&id=3e06b6ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e06b6ba",
  null
  
)

export default component.exports